import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { FormProvider } from "react-hook-form";
import { useTranslate } from "src/locales";
import { usePageTwoForm } from "./hooks/usePageTwoForm";
import PatientNutritionInfo from "./components/PatientNutritionInfo";
import PatientRequestsAndDischarge from "./components/PatientRequestsAndDischarge";
import CatheterOncologyInfo from "./components/CatheterOncologyInfo";

const PageTwo: React.FC = () => {
  const { formMethods, onSubmit } = usePageTwoForm();
  const { t } = useTranslate();

  return (
    <FormProvider {...formMethods}>
      <Box sx={{ paddingTop: "20px" }}>
        <Grid container spacing={2}>
          <Box
            sx={{
              border: "1px solid #DBDBDB",
              borderRadius: "4px",
              padding: "20px",
              width: "100%",
            }}
          >
            <form onSubmit={onSubmit}>
              <PatientNutritionInfo />

              <Box sx={{ my: 4 }}>
                <PatientRequestsAndDischarge />
              </Box>

              <Box sx={{ my: 4 }}>
                <CatheterOncologyInfo />
              </Box>

              <Box sx={{ mt: 4, textAlign: "right" }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  sx={{ borderRadius: "20px", textTransform: "none", px: 4 }}
                >
                  {t("buttons.save")}
                </Button>
              </Box>
            </form>
          </Box>
        </Grid>
      </Box>
    </FormProvider>
  );
};

export default PageTwo;
